import UserCentricsClient, { InitOptions } from '@usercentrics/cmp-browser-sdk';
import { useEffect, useState } from 'react';
import { loadUsercentrics } from './UsercentricsContext/loadUsercentrics';

export function useUserCentricsClient(
  userCentricsId: string,
  options: InitOptions
): { client: UserCentricsClient | null; isLoading: boolean } {
  const [client, setClient] = useState<UserCentricsClient | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!client) {
      const Client = loadUsercentrics();
      const client: UserCentricsClient = new Client(userCentricsId, options);

      setIsLoading(true);
      client.init().then(() => {
        setIsLoading(false);
        setClient(client);
      });
    }
  }, [client]);

  return {
    client,
    isLoading,
  };
}
